<script setup>
  import ClientInfoComponent from "@/Components/ClientInfo/ClientInfoComponent.vue";
  // import ListComponent from "@/Components/Tasks/ListComponent.vue";
  import ClientContactsClientPageComponent from "@/Components/Clients/ClientContactsClientPageComponent.vue";
  import UploadFilesComponent from "@/Components/ClientFiles/UploadFilesComponent.vue";
  import ListFilesComponent from "@/Components/ClientFiles/ListFilesComponent.vue";
  import MessagesClientComponent from "@/Components/Messaging/MessagesClientComponent.vue";
  import NotesComponent from "@/Components/Notes/NotesComponent.vue";
  import BlockPersonClientViewComponent from "@/Components/BlockPersonClientView/BlockPersonClientViewComponent.vue";
  import ReviewerListComponent from "@/Components/Reviewers/ReviewerListComponent.vue";
  import {useRoute} from "vue-router";
  import {Permissions} from "@/Utils/Permissions";
  import {onMounted, reactive} from "vue";
  import {ApiWrapper} from "@/Utils/ApiWrapper";
  const route = useRoute();

  const data = reactive({
    loading: true,
    exists: false
  });

  const checkExists = () => {
    data.loading = true;
    data.exists = false;
    ApiWrapper.post('clients', 'client-exists', {
      clientId: route.params.clientId
    })
        .then((response) => {
          data.exists = true;
        })
        .catch((e)=>{
          data.exists = false;
        })
        .finally(()=>{
          data.loading = false;
        });

  }
  onMounted(() => {
    checkExists();
  });
</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-alert title="Not Found" text="The specified client could not be found" type="error"></v-alert>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-row>
      <v-col cols="12" v-if="Permissions.checkPermissions(['clients.read'])">
        <ClientInfoComponent contextSchemaA="clients" :contextIdA="route.params.clientId"/>
      </v-col>
<!--      <v-col cols="6" v-if="Permissions.checkPermissions(['tasks.list'])">-->
<!--        <ListComponent :clientId="route.params.clientId"/>-->
<!--      </v-col>-->
    </v-row>
    <v-row>
      <v-col cols="6" v-if="Permissions.checkPermissions(['clients.list-contacts'])">
        <ClientContactsClientPageComponent contextSchemaA="clients" :contextIdA="route.params.clientId"/>
      </v-col>
      <v-col cols="6">
        <v-row>
          <UploadFilesComponent v-if="Permissions.checkPermissions(['files.upload'])" :clientId="route.params.clientId"/>
          <ListFilesComponent v-if="Permissions.checkPermissions(['files.list'])" :clientId="route.params.clientId"/>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col cols="6" v-if="Permissions.checkPermissions(['messages.list'])">
        <MessagesClientComponent contextSchemaA="clients" :contextIdA="route.params.clientId"/>
      </v-col>
      <v-col cols="6" v-if="Permissions.checkPermissions(['notes.list'])">
        <NotesComponent :clientId="route.params.clientId"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" v-if="Permissions.checkPermissions(['blocks.list'])">
        <BlockPersonClientViewComponent contextSchemaA="clients" :contextIdA="route.params.clientId"/>
      </v-col>
      <v-col cols="6" v-if="Permissions.checkPermissions(['reviewers.list'])">
        <ReviewerListComponent contextSchemaA="clients" :contextIdA="route.params.clientId"/>
      </v-col>
    </v-row>
  </template>
</template>

<style scoped>

</style>